import { LogStreamType } from 'Generated/schema';

export const eventLogs = [
  `{ "ip": "10.0.0.1", "username": "user-1@example.com", "country": "France" }`,
  `{ "ip": "10.0.0.2", "username": "user-2@example.com", "country": "France" }`,
  `{ "ip": "10.0.0.3", "username": "user-3@example.com", "country": "France" }`,
];

export const xmlEventLogs = [
  `{ "id": "1", "data": "first log" }`,
  `{ "id": "2", "data": { "level": "info", "text": "second log" } }`,
  `{ "id": "3", "meta": { "source": "app" } }`,
];

const csvExample = `"10.0.0.1","user-1@example.com","France"
"10.0.0.2","user-2@example.com","France"
"10.0.0.3","user-3@example.com","France"`;

export const cloudwatchExample = `{
  "owner": "111111111111",
  "logGroup": "services/foo/logs",
  "logStream": "111111111111_CloudTrail/logs_us-east-1",
  "messageType": "DATA_MESSAGE",
  "logEvents": [
      {
          "id": "31953106606966983378809025079804211143289615424298221568",
          "timestamp": 1432826855000,
          "message": "{\\"ip\\": \\"10.0.0.1\\", \\"user\\": \\"user-1@example.com\\", \\"country\\": \\"France\\"}"
      },
      {
          "id": "31953106606966983378809025079804211143289615424298221569",
          "timestamp": 1432826855000,
          "message": "{\\"ip\\": \\"10.0.0.2\\", \\"user\\": \\"user-2@example.com\\", \\"country\\": \\"France\\"}"
      },
      {
          "id": "31953106606966983378809025079804211143289615424298221570",
          "timestamp": 1432826855000,
          "message": "{\\"ip\\": \\"10.0.0.3\\", \\"user\\": \\"user-3@example.com\\", \\"country\\": \\"France\\"}"
      }
  ]
}`;

const jsonExample = `// Supported JSON formats 
// 1 - New line delimited JSON (JSONL)
${eventLogs.join('\n')}
  
// 2 - Space delimited JSON
${eventLogs.join(' ')}
  
// 3 - Indented JSON
{ 
  "ip": "10.0.0.1",
  "username": "user-1@example.com",
  "country": "France"
}
{ 
  "ip": "10.0.0.2",
  "username": "user-2@example.com",
  "country": "France"
}
{ 
  "ip": "10.0.0.3",
  "username": "user-3@example.com",
  "country": "France"
}
`;

const xmlExample = `<log>
    <id>1</id>
    <data>first log</data>
</log>
<log>
    <id>2</id>
    <data level="info">second log</data>
</log>
<log>
    <id>3</id>
    <meta>
        <source>app</source>
    </meta>
</log>`;

export const cloudwatchEventLogsWithEnvelope = [
  `{ "ip": "10.0.0.1", "username": "user-1@example.com", "country": "France", "p_header": {"owner": "111111111111", "logGroup": "services/foo/logs", "logStream": "111111111111_CloudTrail/logs_us-east-1"} }`,
  `{ "ip": "10.0.0.2", "username": "user-2@example.com", "country": "France", "p_header": {"owner": "111111111111", "logGroup": "services/foo/logs", "logStream": "111111111111_CloudTrail/logs_us-east-1"} }`,
  `{ "ip": "10.0.0.3", "username": "user-3@example.com", "country": "France", "p_header": {"owner": "111111111111", "logGroup": "services/foo/logs", "logStream": "111111111111_CloudTrail/logs_us-east-1"} }`,
];

export const streamTypesExample: Record<LogStreamType, string> = {
  [LogStreamType.CloudWatchLogs]: cloudwatchExample,
  [LogStreamType.JsonArray]: `[\n\t${eventLogs.join(',\n\t')}\n]`,
  [LogStreamType.Lines]: csvExample,
  [LogStreamType.Json]: jsonExample,
  [LogStreamType.Xml]: xmlExample,
  // We set this to an empty string because we don't want to show an example for auto
  // since it's not a specific format.
  [LogStreamType.Auto]: '',
};
